import { useRef, useState } from "react"
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid'
import Dialog from "@base/Dialog";
import { ButtonSave } from "@base/Button/ButtonForm"
import Toast from '@base/Toast'
import EscolaService from "@services/EscolaService"
import TextField from "@base/Inputs/Text"
import BuscaEscola from '@base/Inputs/BuscaEscola'
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import VisualizadorDeArquivo from "../../../../base/VisualizadorDeArquivo";
import Zoom from "@material-ui/core/Zoom";
import Tooltip from '@material-ui/core/Tooltip';

export const TransferirCartaoDialog = (props) => {

	const toastRef = useRef(null);
	const buscarEscolaTf = useRef(null);

	const [, setStatus] = useState("");
	const [, setListagemStatus] = useState([]);
	const [novaEscola, setNovaEscola] = useState({});
	const [loading, setLoading] = useState(false);

	const [mesmaEscola, setMesmaEscola] = useState(false);
	const [blob, setBlob] = useState("");
	const [visualizar, setVisualizar] = useState(false)

	const escolaEncontrada = (escola) => {
		setNovaEscola(escola);
	};

	const visualizarArquivo = (id) => {

		EscolaService.downloadArquivoCartao(props.processo, undefined, id).then(resultado => {
			setBlob(resultado.data);
			setVisualizar(true)
		}).catch(erro => {
			toastRef.current.show("error", "Não foi posível fazer download do arquivo.");
		});
	}

	const transferirCartoesLote = (codigoInepDestino) => {
		EscolaService.transferirCartoes(props.processo, props.listaDeCartoes.codigoInep ? props.listaDeCartoes.codigoInep : 'sem-escola', codigoInepDestino, { cartoes: props.listaDeCartoes.cartoes })
			.then(ret => {

				props.toastReference.current.show("success", "Cartões transferidos com sucesso!");

				if (props.aoSalvar)
					props.aoSalvar();

				limparFormulario();
			}).catch(error => {
				toastRef.current.show("error", "Ocorreu um Problema ao alterar o status do Cartão: " + (error.response?.data?.mensagens?.join(" ,") || "Erro desconhecido"));
			}).finally(() => {
				setLoading(false);
			});
	}

	const transferirCartao = (codigoInepDestino, cartao, tornarLegivel) => {
		EscolaService.transferirCartao(props.processo, props.listaDeCartoes.codigoInep ? props.listaDeCartoes.codigoInep : 'sem-escola', cartao.id, codigoInepDestino, { nivel: cartao.nivel, tornarLegivel: tornarLegivel })
			.then(ret => {

				props.toastReference.current.show("success", "Cartão transferido com sucesso!");

				if (props.aoSalvar)
					props.aoSalvar();

				limparFormulario();
			}).catch(error => {
				toastRef.current.show("error", "Ocorreu um Problema ao alterar o status do Cartão: " + (error.response?.data?.mensagens?.join(" ,") || "Erro desconhecido"));
			}).finally(() => {
				setLoading(false);
			});
	}

	const submit = () => {
		setLoading(true);

		if (props.listaDeCartoes.cartoes.length > 1) {
			transferirCartoesLote(mesmaEscola ? props.listaDeCartoes.codigoInep : novaEscola.codigoInep);
		} else {
			transferirCartao(mesmaEscola ? props.listaDeCartoes.codigoInep : novaEscola.codigoInep, props.listaDeCartoes.cartoes[0]);
		}
	}

	const submitLegivel = () => {
		setLoading(true);
		transferirCartao(mesmaEscola ? props.listaDeCartoes.codigoInep : novaEscola.codigoInep, props.listaDeCartoes.cartoes[0], true);
	}

	const limparFormulario = () => {
		setStatus("");
		setListagemStatus([]);
	}

	const fecharDialog = () => {
		limparFormulario();
		props.aoFechar();
	}
	return (
		<>
			<Toast ref={toastRef} />
			<Dialog
				maxWidth={"lg"}
				fullWidth={true}
				closeDialog={fecharDialog}
				openDialog={props.aberto}
				title={"Transferir Cartões"}
				actions={
					<>
						<ButtonSave loading={loading} name={"Transferir"} onClick={submit} />
						{props.listaDeCartoes.cartoes.length === 1 && !props.listaDeCartoes.cartoes[0].legivel ?
							<ButtonSave loading={loading} name={"Transferir e Tornar Legível"} onClick={submitLegivel} />
							: <></>
						}
					</>
				}>

				<Grid container>
					<Grid item sm={12}>
						<TextField
							label="Escola Atual"
							value={props.listaDeCartoes.escolaNome ? props.listaDeCartoes.escolaNome : 'Sem Escola Vinculada'}
							readonly={true}
						/>
					</Grid>
				</Grid>

				<Grid container >
					<Grid item sm={12}>
						<List>
							{props.listaDeCartoes.cartoes && props.listaDeCartoes.cartoes.length > 0 ? (
								props.listaDeCartoes.cartoes.map((cartao, index) => (
									<Tooltip title={"Visualizar Arquivo"} TransitionComponent={Zoom}>
										<ListItem button onClick={() => visualizarArquivo(cartao.id)} key={index}>
											<ListItemText primary={cartao.codigo} style={{ textDecoration: 'underline' }} />
										</ListItem>
									</Tooltip>
								))
							) : (
								<Grid>Nenhum cartão disponível.</Grid>
							)}
						</List>
					</Grid>
				</Grid>


				{props.listaDeCartoes.codigoInep &&
					<Grid container>
						<Grid item sm={12}>
							<Checkbox
								defaultChecked
								color="primary"
								checked={mesmaEscola}
								onChange={event => {
									setMesmaEscola(event.target.checked);

								}}
								inputProps={{ 'aria-label': 'Selecionar Todos' }}
							/> Utilizar mesmo INEP

						</Grid>
					</Grid>}

				{!mesmaEscola && !novaEscola.nome &&
					<Grid container>
						<Grid item sm={12}>
							<BuscaEscola
								inputRef={buscarEscolaTf}
								size={4}
								autoFocus
								ocultarsubtitulo
								label={"Nova Escola"}
								processo={props.processo}
								aoencontrar={escolaEncontrada}
								aonaoencontrar={() => { }}
							/>
						</Grid>
					</Grid>}

				{!mesmaEscola && novaEscola.nome &&
					<Grid container >
						<Grid item sm={12}>
							<TextField
								label="Nova Escola"
								value={novaEscola.nome}
								readonly={true}
							/>
						</Grid>
					</Grid>}
				{visualizar && <VisualizadorDeArquivo blob={blob} />}

			</Dialog>
		</>
	);
}

export default TransferirCartaoDialog;
